// The dimmed magma behind every sign-in page (owner, 8 Oct: "Dimmed magma"; 10 Oct: "use the real
// shared animation ... here react to mouse unlike call page"; TwoShot's is the same magma at its own
// crimson). It is the kit's one orb core (@twoshot/ui-kit mountOrb, preset magma-dim): the poster
// paints first, then a still frame, then the live canvas. A device that cannot animate keeps the
// still image; reduced motion holds one frozen frame. The pointer stirs the live magma.
import {useEffect, useRef} from "react";
import {mountOrb} from "@twoshot/ui-kit";
import {activeDeployment} from "../../shared/deployment-config.ts";

export function OrbBackdrop() {
    const host = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const el = host.current;
        if (!el) return;
        const look = activeDeployment().appearance;
        let orb: ReturnType<typeof mountOrb> | null = null;
        try {
            orb = mountOrb(el, {preset: "magma-dim", brand: look.orb, theme: look.theme === "dark" ? "dark" : "auto", live: true});
        } catch (error) {
            // The page works without its backdrop; never let the backdrop take the form down.
            console.warn("[orb] backdrop unavailable", error);
            return;
        }
        // The text never sits on the magma: the backdrop carries a mask cutout round the form (CSS,
        // so the poster, the still and the live canvas all clear alike), and the live magma treats
        // the form as a keep-out box and flows round it (the kit's region boxes). The mount holds the region and gives it
        // to every live canvas before its first frame, so the box is never set over magma already drawn under it.
        const keepOut = () => {
            const form = document.querySelector(".auth-container");
            if (!form) return;
            const frame = el.getBoundingClientRect();
            const r = form.getBoundingClientRect();
            el.style.setProperty("--form-cx", `${r.left - frame.left + r.width / 2}px`);
            el.style.setProperty("--form-cy", `${r.top - frame.top + r.height / 2}px`);
            el.style.setProperty("--form-w", `${r.width}px`);
            el.style.setProperty("--form-h", `${r.height}px`);
            orb?.setRegion({boxes: [{x0: r.left - frame.left, y0: r.top - frame.top, x1: r.right - frame.left, y1: r.bottom - frame.top, r: 12, margin: 0, reach: 96}]});
        };
        keepOut();
        const formSize = typeof ResizeObserver === "function" ? new ResizeObserver(keepOut) : null;
        const form = document.querySelector(".auth-container");
        if (form) formSize?.observe(form);
        window.addEventListener("resize", keepOut);
        const move = (e: PointerEvent) => {
            const ctl = orb?.controller();
            if (!ctl) return;
            const r = el.getBoundingClientRect();
            ctl.pointer(e.clientX - r.left, e.clientY - r.top);
        };
        const leave = () => orb?.controller()?.pointer(null);
        window.addEventListener("pointermove", move, {passive: true});
        document.documentElement.addEventListener("pointerleave", leave);
        window.addEventListener("blur", leave);
        return () => {
            formSize?.disconnect();
            window.removeEventListener("resize", keepOut);
            window.removeEventListener("pointermove", move);
            document.documentElement.removeEventListener("pointerleave", leave);
            window.removeEventListener("blur", leave);
            orb?.destroy();
        };
    }, []);
    return <div className="orb-backdrop" ref={host} aria-hidden="true"/>;
}
